import React, { useMemo } from "react";

import { Anchor } from "@mantine/core";

import { MightierCheckbox } from "@components/MightierCheckbox/index";
import { Trans, useTranslation } from "react-i18next";

import type { AccountActivateForm } from "src/services/accountActivation/accountActivationTypes";

import type { MightierSupportedLanguage } from "@neuromotion-inc/mightier-ts-sdk";

export const McsConsentToTreatInput: React.FC<{
  form: AccountActivateForm;
}> = ({ form }) => {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language as MightierSupportedLanguage;

  const consentDocURL = useMemo(() => {
    // see mcs-public-frontend repo, this calculation matches that
    const formattedLng = currentLanguage.replace("-", "_").toUpperCase();
    // TODO: you might want to replace this w/ env dependent version?
    return `/MCS_CONSENT_${formattedLng}_v2.0.html`;
  }, [currentLanguage]);

  return (
    <>
      <iframe
        src={consentDocURL}
        style={{ width: "100%", height: "500px" }}
        data-testid="mcs-consent-to-treat-doc-iframe"
      />

      <MightierCheckbox
        {...form.getInputProps("mcsIntakeConsentAccepted", {
          type: "checkbox",
        })}
        label={
          <Trans
            i18nKey="startPage.mcsConsentToTreat"
            components={{
              1: (
                <Anchor
                  href={consentDocURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: "inherit" }}
                />
              ),
            }}
          />
        }
        data-testid="mcs-consent-to-treat-doc-checkbox"
      />
    </>
  );
};
